import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class PriceListRegionAPI {
    public static async getAll(): Promise<AxiosResponse> {
        try {
            return await ApiController.get(ApiRoutes.priceListRegion.get) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async create(data: { name: string }): Promise<AxiosResponse> {
        const request = {
            data: {
                type: 'price_list_regions',
                attributes: {
                    name: data.name,
                    importId: data.name,
                },
            },
        };
        try {
            return await ApiController.post(ApiRoutes.priceListRegion.get, request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async update(id: string | number, data: { name: string }): Promise<AxiosResponse> {
        const request = {
            data: {
                id: id.toString(),
                type: 'price_list_regions',
                attributes: {
                    name: data.name,
                },
            },
        };
        try {
            return await ApiController.patch(ApiRoutes.priceListRegion.byId(id), request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async delete(id: string | number): Promise<AxiosResponse> {
        try {
            return await ApiController.delete(ApiRoutes.priceListRegion.byId(id)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async setDefault(id: string | number): Promise<AxiosResponse> {
        try {
            return await ApiController.post(ApiRoutes.priceListRegion.setDefault(id), {}) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}